"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var skynet_store_messages_api_1 = require("@synisys/skynet-store-messages-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var utilities_1 = require("../utilities");
var logger = utilities_1.createLogger('translation-service');
var TranslationService = /** @class */ (function () {
    function TranslationService(store) {
        this.store = store;
        this.currentLanguageId$ = this.store.select(function (state) { return state.languages.currentLanguageId; });
    }
    TranslationService.prototype.translate = function (name, defaultValue, replaceTo) {
        var _this = this;
        if (defaultValue === void 0) { defaultValue = ''; }
        if (replaceTo === void 0) { replaceTo = []; }
        return this.currentLanguageId$.pipe(operators_1.switchMap(function (languageId) {
            if (lodash_1.isNil(languageId)) {
                logger.error("Current language is " + languageId);
                return of_1.of(defaultValue);
            }
            return skynet_store_messages_api_1.messageStoreManager
                .selectOne(_this.store, skynet_store_messages_api_1.MessageKeyFactory({ name: name, languageId: languageId }))
                .pipe(operators_1.map(function (msg) { return (msg ? msg.value : defaultValue); }));
        }), operators_1.map(function (message) {
            return message
                ? replaceTo.reduce(function (previousValue, currentValue, i) {
                    return previousValue.replace("{" + i + "}", currentValue);
                }, message)
                : '';
        }));
    };
    TranslationService.prototype.translateMultilingual = function (multilingual, defaultValue) {
        if (defaultValue === void 0) { defaultValue = ''; }
        if (lodash_1.isNil(multilingual)) {
            return of_1.of(defaultValue);
        }
        if (lodash_1.isString(multilingual)) {
            return of_1.of(multilingual);
        }
        return this.currentLanguageId$.pipe(operators_1.map(function (language) {
            if (lodash_1.isNil(language)) {
                logger.error("Current language is " + language);
                return defaultValue;
            }
            else if (multilingual instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
                return multilingual.getValue(language);
            }
            else if (skynet_store_utilities_1.notNil(multilingual[language])) {
                return multilingual[language];
            }
            else {
                return defaultValue;
            }
        }));
    };
    TranslationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [store_1.Store])
    ], TranslationService);
    return TranslationService;
}());
exports.TranslationService = TranslationService;
//# sourceMappingURL=translation.service.js.map